import { isCompleteMapping } from './guessMapping';
import { pivotSheets } from './pivotPriceBreaks';
import type {
  GuessedMapping,
  ParseWorkbookResult,
  PivotFileView,
  PivotedSheet,
  SheetPivotResult,
} from './types';

function skippedNames(results: readonly SheetPivotResult[]): string[] {
  return results.flatMap((result) =>
    result.status === 'missing-columns' ? [result.sheetName] : [],
  );
}

function pivotedSheets(results: readonly SheetPivotResult[]): PivotedSheet[] {
  return results.flatMap((result) =>
    result.status === 'pivoted' ? [result.sheet] : [],
  );
}

export function toPivotFileView(
  result: ParseWorkbookResult,
  mapping: GuessedMapping,
): PivotFileView {
  if (result.status === 'unreadable') {
    return { status: 'unreadable', id: result.id, fileName: result.fileName };
  }
  if (result.status === 'empty') {
    return { status: 'empty', id: result.id, fileName: result.fileName };
  }
  if (!isCompleteMapping(mapping)) {
    return {
      status: 'needs-mapping',
      id: result.id,
      fileName: result.fileName,
    };
  }
  const sheetResults = pivotSheets(result.workbook.sheets, mapping);
  const sheets = pivotedSheets(sheetResults);
  const skippedSheets = skippedNames(sheetResults);
  if (sheets.length === 0) {
    return {
      status: 'unrecognized',
      id: result.id,
      fileName: result.fileName,
      skippedSheets,
    };
  }
  return {
    status: 'pivoted',
    id: result.id,
    fileName: result.fileName,
    sheets,
    skippedSheets,
  };
}

export function toPivotFileViews(
  results: readonly ParseWorkbookResult[],
  mapping: GuessedMapping,
): PivotFileView[] {
  return results.map((result) => toPivotFileView(result, mapping));
}
